import { useRouter } from 'next/router';
import { useUserProfile } from '@hooks/user';
import { getCreatorPageUrl, saveCreatorPageEntryPoint } from '@libraries/auth';

export default function useNavigateCreatorPage(replace?: boolean) {
  const router = useRouter();
  const { userProfile, isSignedOut } = useUserProfile();

  const moveToCreatorPage = () => {
    const isStartPage = router.pathname === '/start';
    const url = getCreatorPageUrl({ userProfile, isSignedOut, isStartPage });

    replace ? router.replace(url) : router.push(url);
  };

  const navigateCreatorPage = (
    screenSection?: string | null,
    entryPointData?: Object,
  ) => {
    setDataEvent(screenSection);
    saveCreatorPageEntryPoint(entryPointData);
    moveToCreatorPage();
  };

  return navigateCreatorPage;
}

const setDataEvent = (screen_section?: string | null) =>
  screen_section &&
  window.steadioAnalytics.track('Clicked Start Creator Button', {
    screen_section,
  });
